import BasicLayout from '@/layouts/basic-layout'

const prefix = 'building-manage-'
export default [
  {
    path: '/base-manage/building-manage',
    redirect: {name: `${prefix}index`},
    component: BasicLayout,
    children: [
      {
        path: 'index',
        name: `${prefix}index`,
        meta: {title: '楼栋管理'},
        component: () => import('@/pages/base-manage/building-manage/index')
      },
      {
        path: 'detail-create',
        name: `${prefix}create`,
        auth: ['hidden'],
        meta: {title: '楼栋新增'},
        component: () => import('@/pages/base-manage/building-manage/detail-create')
      },
      {
        path: 'detail-edit/:id',
        name: `${prefix}edit`,
        auth: ['hidden'],
        meta: {title: '楼栋编辑'},
        component: () => import('@/pages/base-manage/building-manage/detail-edit')
      },
      {
        path: 'detail-view/:id',
        name: `${prefix}view`,
        auth: ['hidden'],
        meta: {title: '楼栋详情'},
        component: () => import('@/pages/base-manage/building-manage/detail-view')
      }
    ]
  }
]
